import styled from "styled";

/**
 * An image element that has the "display" style set to "block" and by default
 * expands to fill its container's width.
 */
export const BlockImage = styled.img`
  display: block;
  width: 100%;
`;
